import Vue from "vue";
import Vuex from "vuex";
import { cityModule } from "./modules/city";
import { socialModule } from "./modules/social";
Vue.use(Vuex);

export const mutationTypes = {
  setIsOpenMenu: "mutation/setIsOpenMenu",
  setIsOpenSelectCity: "mutation/setIsOpenSelectCity",

  setCurrentLanguage: "mutation/setCurrentLanguage",
};
export const actionTypes = {
  changeIsOpenMenu: "action/changeIsOpenMenu",
  changeIsOpenSelectCity: "action/changeIsOpenSelectCity",
  changeIsCloseMenu: "action/changeIsCloseMenu",

  changeCurrentLanguage: "action/changeCurrentLanguage",
};

export default new Vuex.Store({
  state: {
    isOpenMenu: false,
    isOpenSelectCity: false,
    currentLanguage: "ru",
    searchItem: null,
  },
  mutations: {
    SET_SEARCH_ITEM(state, payload) {
      state.searchItem = payload;
    },
    [mutationTypes.setIsOpenMenu](state) {
      state.isOpenMenu = !state.isOpenMenu;
      if (state.isOpenMenu) {
        document.querySelector("body").classList.add("no-scroll");
      } else {
        document.querySelector("body").classList.remove("no-scroll");
      }
    },
    [mutationTypes.setIsOpenSelectCity](state) {
      state.isOpenSelectCity = !state.isOpenSelectCity;
    },
    [mutationTypes.setCurrentLanguage](state, payload) {
      state.currentLanguage = payload;
    },
  },
  actions: {
    [actionTypes.changeIsOpenMenu]({ commit }) {
      commit(mutationTypes.setIsOpenMenu);
    },
    [actionTypes.changeIsOpenSelectCity]({ commit }) {
      commit(mutationTypes.setIsOpenSelectCity);
    },
    [actionTypes.changeIsCloseMenu]({ commit }) {
      commit(mutationTypes.setIsOpenMenu);
    },
    [actionTypes.changeCurrentLanguage]({ commit }, lang) {
      commit(mutationTypes.setCurrentLanguage, lang);
    },
  },
  modules: {
    cityModule,
    socialModule,
  },
});
